import { Reducer } from 'redux';
import { PetBreakdownReportState, PetBreakdownReportStatus } from './PetBreakdownReportState';
import { PetBreakdownReport } from 'model/ClientAndPetsReport';
import {
    PET_BREAKDOWN_REPORT_GET_START,
    PET_BREAKDOWN_REPORT_GET_SUCCESS,
    PET_BREAKDOWN_REPORT_GET_ERROR,
    PetBreakdownReportAction
} from 'actions/insights/clientsAndPets/petBreakdown/PetBreakdownReportActionsTypes';

const emptyReport: PetBreakdownReport = {
    pets: [],
    meta: {
        page: 1,
        perPage: 10,
        totalCount: 0,
        totalPages: 0
    }
};

const initialState: PetBreakdownReportState = {
    report: emptyReport,
    status: PetBreakdownReportStatus.Initial,
    loading: false
};

export const PetBreakdownReportReducer: Reducer<PetBreakdownReportState, PetBreakdownReportAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case PET_BREAKDOWN_REPORT_GET_START:
            return {
                ...state,
                status: PetBreakdownReportStatus.Getting,
                loading: true
            };
        case PET_BREAKDOWN_REPORT_GET_SUCCESS:
            return {
                ...state,
                report: action.payload.report,
                status: PetBreakdownReportStatus.GettingSuccess,
                loading: false
            };
        case PET_BREAKDOWN_REPORT_GET_ERROR:
            return {
                ...state,
                status: PetBreakdownReportStatus.Error,
                loading: false
            };
        default:
            return state;
    }
};
